/* eslint-disable react-hooks/exhaustive-deps */
import { Container, Row, Col, Card } from "react-bootstrap"
import AlertComponent from "../../../components/AlertComponent"
import * as WjRNav from "@grapecity/wijmo.react.nav"
import CONSTANT from "../../../constant"
import { useEffect, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "../../../globalStore/rootreducer"
import { AppDispatch } from "../../.."
import {
  getZyomuin,
  TZyomuinMasterState,
  zyomuinMasterActions,
} from "../../../globalStore/pageStore/zyomuinMaster/zyomuinMasterStore"
import { Button } from "react-bootstrap"
import { setAlerts, setWarningAlerts } from "../../../globalStore/alertStore"
import MainDataPane from "./AccordionPanes/MainDataPane"
import KyoikuKensyuJusinPane from "./AccordionPanes/KyoikuKensyuJusinPane"
import KakusyuRirekiPane from "./AccordionPanes/KakusyuRirekiPane"
import BsyoIdoRirekiPane from "./AccordionPanes/BsyoIdoRirekiPane"
import { Prompt, useHistory, useParams } from "react-router-dom"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import Ajv from "ajv"
import ajvErrors from "ajv-errors"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import ZyomuinService from "../../../service/driver/zyomuinService"
import { showInfoToast } from "../../../components/CustomToast"
import {
  TZyomuinAlcoholHannoListReqItem,
  TZyomuinClaimListReqItem,
  TZyomuinHyosyorekiListReqItem,
  TZyomuinJikorekiListReqItem,
  TZyomuinKeirekiListReqItem,
  TZyomuinMenkyoFileListReqItem,
  TZyomuinMenkyoKosinListReqItem,
  TZyomuinPutReq,
  TZyomuinSidorekiListReqItem,
  TZyomuinSikakuListReqItem,
  TZyomuinSyozokuMasterPutReq,
  TZyomuinUntenKirokuListReqItem,
  TZyomuinZenrekiListReqItem,
} from "../../../service/driver/TZyomuin"
import { メニューコード } from "../../../constant/menuCode"
import {
  TBlobContextItem,
  ZyomuinMasterRegisterProvider,
} from "./ZyomuinMasterRegisterContext"
import ContentService from "../../../service/content/contentService"

//#region [type]

export type T乗務員マスタデータ = TZyomuinMasterState

//#endregion

/**
 * 乗務員マスタ登録
 * @returns
 */
const ZyomuinMasterRegister = () => {
  const history = useHistory()
  const { id: paramId } = useParams<{ id: string }>()
  const id = paramId ? parseInt(paramId) : undefined
  //#region selector
  //TODO: any対応のため、型定義する
  const zyomuinMaster: TZyomuinMasterState = useSelector(
    (state: RootState) => state.page.zyomuinMaster
  )

  const 読取専用フラグ = useSelector(
    (rootState: RootState) =>
      rootState.menu.menuPage.find(
        (m) => m.メニューコード === メニューコード.乗務員管理.乗務員マスタ登録
      )?.読み取り専用フラグ
  )

  const disPatch: AppDispatch = useDispatch()

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  //#endregion
  //#region [state]

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)

  // 初期化制御
  const [isInitialized, setIsInitialized] = useState(false)
  const [isLoadEnded, setIsLoadEnded] = useState(false)
  const [isDispatch乗務員Ended, setIsDispatch乗務員Ended] =
    useState<boolean>(false)
  const [isPictureLoaded, setIsPictureLoaded] = useState<boolean>(false)

  // 各種パネルの初期化制御
  const [isMainDataPaneLoadEnded, setIsMainDataPaneLoadEnded] = useState(false)

  // BlobContext用
  const refBlobList = useRef<TBlobContextItem[]>()
  const [blobList, setBlobList] = useState<TBlobContextItem[]>([])

  //#endregion

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    //TODO: ここにバリデーションチェックを実装
    const ajv = new Ajv({ allErrors: true })
    ajvErrors(ajv)
    setIsConfirmModalShow(true)
  }

  /**
   * 送信
   */
  const submit = async () => {
    try {
      const service = new ZyomuinService()
      if (id) {
        const reqData = getPutReq()
        await service.put(id, reqData)
      }
      //  else {
      //   await service.post(getPostReq())
      // }
      isPrompt.current = false
      history.goBack()
      showInfoToast(`乗務員マスタの${id ? "更新" : "登録"}が完了しました`)
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  /**
   * 更新アイテム生成
   */
  const getPutReq = (): TZyomuinPutReq => {
    return {
      社員コード: zyomuinMaster.社員コード!,
      選任日: zyomuinMaster.選任日 ?? "",
      選任種類: zyomuinMaster.選任種類 ?? "",
      携帯アドレス: zyomuinMaster.携帯アドレス ?? "",
      緊急連絡先: zyomuinMaster.緊急連絡先 ?? "",
      緊急連絡先番号: zyomuinMaster.緊急連絡先番号 ?? "",

      Is顔写真削除:
        zyomuinMaster.Has顔写真AtStart &&
        (zyomuinMaster.顔写真 == null || zyomuinMaster.顔写真.isNewFile)
          ? true
          : false,
      顔写真:
        zyomuinMaster.顔写真 != null && zyomuinMaster.顔写真.isNewFile
          ? blobList.find((b) => b.id === zyomuinMaster.顔写真?.row_id)?.blob
          : undefined,

      免許取得日: zyomuinMaster.免許取得日 ?? "",
      免許証番号: zyomuinMaster.免許証番号 ?? "",

      免許大型フラグ: zyomuinMaster.免許大型フラグ,
      免許中型フラグ: zyomuinMaster.免許中型フラグ,
      免許普通フラグ: zyomuinMaster.免許普通フラグ,
      免許大特フラグ: zyomuinMaster.免許大特フラグ,
      免許大自二フラグ: zyomuinMaster.免許大自二フラグ,
      免許普自二フラグ: zyomuinMaster.免許普自二フラグ,
      免許小特フラグ: zyomuinMaster.免許小特フラグ,
      免許原付フラグ: zyomuinMaster.免許原付フラグ,
      免許け引フラグ: zyomuinMaster.免許け引フラグ,
      免許大二フラグ: zyomuinMaster.免許大二フラグ,
      免許中二フラグ: zyomuinMaster.免許中二フラグ,
      免許普二フラグ: zyomuinMaster.免許普二フラグ,
      免許大特二フラグ: zyomuinMaster.免許大特二フラグ,
      免許け引二フラグ: zyomuinMaster.免許け引二フラグ,

      免許条件1: zyomuinMaster.免許条件1 ?? "",
      免許条件2: zyomuinMaster.免許条件2 ?? "",
      免許条件3: zyomuinMaster.免許条件3 ?? "",

      運転記録最終取得日: zyomuinMaster.運転記録最終取得日 ?? "",
      SDカード色: zyomuinMaster.SDカード色 ?? "",
      無事故年数: zyomuinMaster.無事故年数,

      前歴リスト: zyomuinMaster.前歴データリスト.map(
        (item): TZyomuinZenrekiListReqItem => {
          return {
            乗務員前歴ID: item.乗務員前歴ID,
            入学入社日: item.入学入社日 ?? "",
            卒業退社日: item.卒業退社日 ?? "",
            学校会社名: item.学校会社名 ?? "",
            備考: item.備考 ?? "",
            削除フラグ: item.削除フラグ === 1 ? 1 : 0,
            更新日時: item.更新日時,
          }
        }
      ),
      経歴リスト: zyomuinMaster.経歴データリスト.map(
        (item): TZyomuinKeirekiListReqItem => {
          return {
            乗務員経歴ID: item.乗務員経歴ID,
            自動車種類: item.自動車種類 ?? "",
            車載量: item.車載量 ?? "",
            経験年数: item.経験年数,
            主な事業所: item.主な事業所 ?? "",
            削除フラグ: item.削除フラグ === 1 ? 1 : 0,
            更新日時: item.更新日時,
          }
        }
      ),
      資格リスト: zyomuinMaster.資格データリスト.map(
        (item): TZyomuinSikakuListReqItem => {
          return {
            乗務員資格歴ID: item.乗務員資格歴ID,
            資格取得日: item.資格取得日 ?? "",
            資格名称: item.資格名称 ?? "",
            資格番号: item.資格番号 ?? "",
            備考: item.備考 ?? "",
            削除フラグ: item.削除フラグ === 1 ? 1 : 0,
            更新日時: item.更新日時,
          }
        }
      ),
      表彰歴リスト: zyomuinMaster.表彰歴データリスト.map(
        (item): TZyomuinHyosyorekiListReqItem => {
          return {
            乗務員表彰歴ID: item.乗務員表彰歴ID,
            表彰日: item.表彰日 ?? "",
            表彰名称: item.表彰名称 ?? "",
            表彰組織: item.表彰組織 ?? "",
            内容: item.内容 ?? "",
            削除フラグ: item.削除フラグ === 1 ? 1 : 0,
            更新日時: item.更新日時,
          }
        }
      ),
      指導歴リスト: zyomuinMaster.指導懲戒歴データリスト.map(
        (item): TZyomuinSidorekiListReqItem => {
          return {
            乗務員指導懲戒歴ID: item.乗務員指導懲戒歴ID,
            指導懲戒日: item.指導懲戒日 ?? "",
            指導懲戒区分ID: item.指導懲戒区分ID,
            指導懲戒名称: item.指導懲戒名称 ?? "",
            指導者: item.指導者 ?? "",
            内容: item.内容 ?? "",
            削除フラグ: item.削除フラグ === 1 ? 1 : 0,
            更新日時: item.更新日時,
          }
        }
      ),
      免許更新リスト: zyomuinMaster.免許更新履歴データリスト.map(
        (item): TZyomuinMenkyoKosinListReqItem => {
          return {
            乗務員免許更新歴ID: item.乗務員免許更新歴ID,
            免許更新日: item.免許更新日 ?? "",
            免許証番号: item.免許証番号 ?? "",
            有効期限: item.有効期限 ?? "",
            SDカード色: item.SDカード色 ?? "",
            面談日: item.面談日 ?? "",
            面談者: item.面談者 ?? "",
            面談内容: item.面談内容 ?? "",
            削除フラグ: item.削除フラグ === 1 ? 1 : 0,
            更新日時: item.更新日時,
          }
        }
      ),
      免許ファイルリスト: zyomuinMaster.免許ファイルリスト.map(
        (item): TZyomuinMenkyoFileListReqItem => {
          return {
            乗務員運転免許添付資料ID: item.乗務員運転免許添付資料ID,
            Isファイル削除:
              item.HasファイルAtStart &&
              (item.ファイル == null || item.ファイル.isNewFile)
                ? true
                : false,
            ファイル:
              item.ファイル != null && item.ファイル.isNewFile
                ? blobList.find((b) => b.id === item.row_id)?.blob
                : undefined,
            削除フラグ: item.削除フラグ === 1 ? 1 : 0,
            更新日時: item.更新日時,
          }
        }
      ),
      事故履歴リスト: zyomuinMaster.事故歴データリスト.map(
        (item): TZyomuinJikorekiListReqItem => {
          return {
            乗務員事故歴ID: item.乗務員事故歴ID,
            車番: item.車番 ?? "",
            発生日: item.発生日 ?? "",
            事故種類: item.事故種類 ?? "",
            責任: item.責任 ?? "",
            概要: item.概要 ?? "",
            Is添付ファイル削除:
              item.Has添付ファイルAtStart &&
              (item.添付ファイル == null || item.添付ファイル.isNewFile)
                ? true
                : false,
            添付ファイル:
              item.添付ファイル != null && item.添付ファイル.isNewFile
                ? blobList.find((b) => b.id === item.row_id)?.blob
                : undefined,
            削除フラグ: item.削除フラグ === 1 ? 1 : 0,
            更新日時: item.更新日時,
          }
        }
      ),
      運転記録リスト: zyomuinMaster.運転記録証明データリスト.map(
        (item): TZyomuinUntenKirokuListReqItem => {
          return {
            乗務員運転記録証明ID: item.乗務員運転記録証明ID,
            違反日: item.違反日 ?? "",
            違反内容: item.違反内容 ?? "",
            違反点数: item.違反点数,
            備考: item.備考 ?? "",
            削除フラグ: item.削除フラグ === 1 ? 1 : 0,
            更新日時: item.更新日時,
          }
        }
      ),
      クレームリスト: zyomuinMaster.クレーム歴データリスト.map(
        (item): TZyomuinClaimListReqItem => {
          return {
            乗務員クレーム歴ID: item.乗務員クレーム歴ID,
            車番: item.車番 ?? "",
            発生日: item.発生日 ?? "",
            場所: item.場所 ?? "",
            概要: item.概要 ?? "",
            相手先氏名: item.相手先氏名 ?? "",
            相手先電話番号: item.相手先電話番号 ?? "",
            対応者: item.対応者 ?? "",
            受付日: item.受付日 ?? "",
            Is添付ファイル削除:
              item.Has添付ファイルAtStart &&
              (item.添付ファイル == null || item.添付ファイル.isNewFile)
                ? true
                : false,
            添付ファイル:
              item.添付ファイル != null && item.添付ファイル.isNewFile
                ? blobList.find((b) => b.id === item.row_id)?.blob
                : undefined,
            削除フラグ: item.削除フラグ === 1 ? 1 : 0,
            更新日時: item.更新日時,
          }
        }
      ),
      アルコール反応リスト: zyomuinMaster.アルコール反応データリスト.map(
        (item): TZyomuinAlcoholHannoListReqItem => {
          return {
            運転者AL反応歴ID: item.運転者AL反応歴ID,
            測定日時: item.測定日時 ?? "",
            AL測定値: item.AL測定値,
            AL判定レベル: item.AL判定レベル ?? "",
            再測定フラグ: item.再測定フラグ,
            削除フラグ: item.削除フラグ === 1 ? 1 : 0,
            更新日時: item.更新日時,
          }
        }
      ),
      乗務員部所異動履歴リスト: zyomuinMaster.部所異動履歴データリスト.map(
        (item): TZyomuinSyozokuMasterPutReq => {
          return {
            所属部所ID: item.所属部所ID,
            会社: item.会社コード,
            異動先_部所コード: item.部所コード,
            異動先_所属開始日: item.所属開始日,
            異動先_備考: item.備考,
            異動先_部所名: item.部所名,
            削除フラグ: item.削除フラグ,
            更新日時: item.更新日時,
          }
        }
      ),

      更新日時: zyomuinMaster.更新日時!,
    }
  }

  //#endregion

  //#region [effect]

  useEffect(() => {
    document.title = `乗務員マスタ登録 - ${CONSTANT.APP_NAME}`

    // 初期表示生成のため画面ロック
    disPatch(画面ロック開始())
    disPatch(zyomuinMasterActions.init())

    setIsInitialized(true)

    // デストラクタ
    return () => {
      disPatch(zyomuinMasterActions.init())
      if (refBlobList.current != null) {
        refBlobList.current
          .filter((b) => (b.fileUrl ?? "") !== "")
          .forEach((b) => {
            try {
              URL.revokeObjectURL(b.fileUrl!)
            } catch (err) {
              // 握りつぶす
            }
          })
      }
    }
  }, [])

  useEffect(() => {
    refBlobList.current = blobList
  }, [blobList])

  useEffect(() => {
    if (!isInitialized) return
    if (!isMainDataPaneLoadEnded) return

    setIsLoadEnded(true)
  }, [isInitialized, isMainDataPaneLoadEnded])

  useEffect(() => {
    if (!isLoadEnded) return

    if (id != null) {
      disPatch(getZyomuin(id))
        .catch((res) => {
          disPatch(setAlerts(res))
        })
        .finally(() => {
          setIsDispatch乗務員Ended(true)
          disPatch(画面ロック解除())
          isPrompt.current = true
        })
    } else {
      dispatch(setWarningAlerts(["idが不正"]))
      setIsDispatch乗務員Ended(true)
      isPrompt.current = true
    }
  }, [isLoadEnded])

  // 画像の読み込み
  useEffect(() => {
    if (!isDispatch乗務員Ended) return
    if (isPictureLoaded) return

    if (zyomuinMaster.顔写真 != null) {
      const service = new ContentService()
      const taskList = [service.get(zyomuinMaster.顔写真.ファイルURL)]

      // 全ての画像を読み込み
      Promise.allSettled(taskList)
        .then((results) => {
          // 顔写真
          if (0 < results.length && results[0].status === "fulfilled") {
            const result = results[0] as PromiseFulfilledResult<Blob>
            const url = URL.createObjectURL(result.value)

            setBlobList([
              ...blobList,
              {
                id: zyomuinMaster.顔写真?.row_id!,
                blob: result.value,
                fileUrl: url,
              },
            ])
          }
        })
        .finally(() => {
          disPatch(画面ロック解除())
          isPrompt.current = true
          setIsPictureLoaded(true)
        })
    } else {
      disPatch(画面ロック解除())
      isPrompt.current = true
      setIsPictureLoaded(true)
    }
  }, [isPictureLoaded, isDispatch乗務員Ended])

  //#endregion

  return (
    <>
      <ZyomuinMasterRegisterProvider
        blobList={blobList}
        addBlobItem={(newItem) => {
          setBlobList([...blobList, newItem])
        }}
        removeBlobItem={(targetId) => {
          const target = blobList.find((b) => b.id === targetId)
          if (target != null && (target.fileUrl ?? "") !== "") {
            try {
              URL.revokeObjectURL(target.fileUrl!)
            } catch (err) {
              // 握りつぶす
            }
          }
          setBlobList(blobList.filter((item) => item.id !== targetId))
        }}>
        <Prompt
          when={isPrompt.current}
          message={CONSTANT.MESSAGES.BROWSER_BACK}></Prompt>
        <Container fluid>
          {/* 画面タイトル */}
          <Row className="page-title-row">
            <Col className="page-title-col">
              <span className="page-title">
                乗務員マスタ{id ? `更新` : `登録`}
              </span>
            </Col>
          </Row>
          {/* アラート表示 */}
          <Row>
            <Col>
              <AlertComponent />
            </Col>
          </Row>
          {/* アコーディオンメニュー */}
          <Row>
            <Col>
              <Card>
                <Card.Body>
                  <WjRNav.Accordion
                    isAnimated={false}
                    allowExpandMany={true}
                    allowCollapseAll={true}>
                    <WjRNav.AccordionPane>
                      <MainDataPane
                        setIsLoadEnded={
                          setIsMainDataPaneLoadEnded
                        }></MainDataPane>
                    </WjRNav.AccordionPane>
                  </WjRNav.Accordion>
                  <br />
                  <div>
                    {!読取専用フラグ && (
                      <Button
                        type="submit"
                        variant="waiting"
                        onClick={(e) => {
                          e.stopPropagation()
                          e.preventDefault()
                          beforeSubmit()
                        }}>
                        {id ? `更新` : `登録`}
                      </Button>
                    )}
                    <Button
                      type="button"
                      variant="secondary"
                      className="ms-4"
                      onClick={() => history.goBack()}>
                      一覧に戻る
                    </Button>
                  </div>
                </Card.Body>
              </Card>
              <Card>
                {/* 教育研修受診パネル */}
                <Card.Body>
                  <WjRNav.Accordion
                    isAnimated={false}
                    allowExpandMany={true}
                    allowCollapseAll={true}>
                    <WjRNav.AccordionPane>
                      <KyoikuKensyuJusinPane></KyoikuKensyuJusinPane>
                    </WjRNav.AccordionPane>
                  </WjRNav.Accordion>
                </Card.Body>
                {/* 各種履歴パネル */}
                <Card.Body>
                  <WjRNav.Accordion
                    isAnimated={false}
                    allowExpandMany={true}
                    allowCollapseAll={true}>
                    <WjRNav.AccordionPane>
                      <KakusyuRirekiPane></KakusyuRirekiPane>
                    </WjRNav.AccordionPane>
                  </WjRNav.Accordion>
                </Card.Body>
                {/* 部所移動履歴パネル */}
                <Card.Body>
                  <WjRNav.Accordion
                    isAnimated={false}
                    allowExpandMany={true}
                    allowCollapseAll={true}>
                    <WjRNav.AccordionPane>
                      <BsyoIdoRirekiPane></BsyoIdoRirekiPane>
                    </WjRNav.AccordionPane>
                  </WjRNav.Accordion>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          {/* 登録確認 */}
          <ConfirmModal
            isShow={isConfirmModalShow}
            hideHandler={setIsConfirmModalShow}
            submitHandler={submit}>
            入力された内容で{id ? "更新" : "登録"}しますか？
          </ConfirmModal>
        </Container>
      </ZyomuinMasterRegisterProvider>
    </>
  )
}
export default ZyomuinMasterRegister
